// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eis_","importantInfo":"styles_importantInfo__1YDYH"};